"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAuthLink = createAuthLink;

var _uuid = require("uuid");

var _apolloLinkContext = require("apollo-link-context");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createAuthLink({
  getToken,
  getLanguageCode,
  clientName
}) {
  return (0, _apolloLinkContext.setContext)((_, previousContext) => {
    const token = getToken();
    return _objectSpread(_objectSpread({}, previousContext), {}, {
      headers: _objectSpread(_objectSpread({}, token ? {
        authorization: `Bearer ${token}`
      } : {}), {}, {
        'accept-language': previousContext.acceptLanguage || getLanguageCode(),
        'x-dooer-client': clientName,
        'x-dooer-transaction-id': (0, _uuid.v4)()
      })
    });
  });
}